module.exports = __webpack_public_path__ + "static/li-c0f4e698275af8da79faa1f3e0cceaa6.svg";